import { Controller } from '@hotwired/stimulus'
import { showNoticeSnackbar, showErrorSnackbar } from '../snackbar'

export default class extends Controller {
  connect() {
    const flashes = JSON.parse(this.element.dataset.flashes)

    flashes.forEach(([key, value]) => {
      if (key === 'notice') {
        showNoticeSnackbar(value)
      } else if (key === 'alert') {
        showErrorSnackbar(value)
      }
    })

    this.element.remove()
  }
}
